import produce from 'immer';
import { CUSTOM_BILLS, MENU_PAYMENT, SET_SUBTITLE_TEXT, TARIFFS } from '../constants/pagesConstants'
import {
    AUTH,
    CHECK_KEY,
    FAILURE,
    LOGOUT,
    REGISTER,
    REQUEST,
    SAVE_CLIENT_SECRET,
    SAVE_KEY,
    ERASE_KEY,
    SAVE_PRODUCT_ID, SAVE_PROMO_CODES,
    SUCCESS,
} from '../constants/constants';
import {
    CHECKOUT,
    PROCEED_TO_CHECKOUT_AFTER_AUTH,
    SWITCH_REGISTRATION_FORM_STATE,
    TOGGLE_REGISTRATION_FORM,
} from '../constants/checkoutConstants';

const initialState = {
    tariffsAll: {},
    tariffs: {},
    products: {},
    promoCodes: {},
    checkoutLoading: false,
    accountFormRegisterState: false,
    accountFormIsVisible: false,
    proceedToCheckoutAfterAuth: false,
    clientSecret: null,
    clientSecretList: [],
    clientSecretRequest: false,
    showCheckoutForm: false,
    sessionKey: getNormalizedItem(localStorage.getItem('ct_account_key')), // #DEPRECATED https://doboard.com/1/task/28527
    paymentPageToken: getNormalizedItem(localStorage.getItem('ct_payment_page_token')),
    productId: +localStorage.getItem('ct_product_id') || 1,
    SET_SUBTITLE_TEXT,
    isLoading: false,
    isLoaded: false,
    paymentMenu: [],
    customBills: [],
};

export function getNormalizedItem(key) {
    const value = localStorage.getItem(key);
    if (value === null) return null; // ключа нет
    if (value === "null" || value === "undefined" || value === "") return null;
    return value;
}

export default produce((draft = initialState, action) => {
    const { type, data } = action;
/*    console.log(type)*/
    switch (type) {
        case TARIFFS + REQUEST:
            draft.isLoading = true;
            break;
        case TARIFFS + SUCCESS:
            if (data?.products && Object.keys(data?.products).length > 0) {
                draft.products = data.products;
            }
            if (data?.tariffs && Object.keys(data?.tariffs).length > 0) {
                draft.tariffsAll = Object.values(data.tariffs)?.reduce((memo, tariff) => {
                    memo[tariff?.tariff_id] = { ...tariff };
                    return memo;
                }, {});
                draft.tariffs = Object.values(data.tariffs)
                    .filter((tariff) => !!tariff?.periods)
                    ?.reduce((acc, tariff) => {
                        acc[tariff?.tariff_id] = {
                            ...tariff,
                        };

                        return acc;
                    }, {});
            }
            draft.isLoading = false;
            draft.isLoaded = true;
            break;
        case TARIFFS + FAILURE:
            draft.isLoading = false;
            draft.isLoaded = true;
            break;
        case SAVE_KEY:
            if (action.sessKey) {
                draft.sessionKey = action.sessKey; // #DEPRECATED https://doboard.com/1/task/28527
            }
            if (action.paymentPageToken) {
                draft.paymentPageToken = action.paymentPageToken;
            }
            break;
        case ERASE_KEY:
            draft.sessionKey = null; // #DEPRECATED https://doboard.com/1/task/28527
            draft.paymentPageToken = null;
            break;
        case CHECK_KEY:
            draft.sessionKey = action.sessKey; // #DEPRECATED https://doboard.com/1/task/28527
            draft.paymentPageToken = action.paymentPageToken;
            break;
        case SAVE_PRODUCT_ID:
            const { productId } = action;
            if (productId) {
                draft.productId = isNaN(Number(productId)) ? productId : +productId;
                localStorage.setItem('ct_product_id', productId);
            }
            break;
        case CHECKOUT + REQUEST:
            draft.checkoutLoading = true;
            break;
        case CHECKOUT + SUCCESS:
            draft.checkoutLoading = false;
            break;
        case CHECKOUT + FAILURE:
            draft.checkoutLoading = false;
            break;
        case TOGGLE_REGISTRATION_FORM:
            draft.accountFormIsVisible = !!data;
            break;
        case SWITCH_REGISTRATION_FORM_STATE:
            draft.accountFormRegisterState = !!data;
            break;
        case PROCEED_TO_CHECKOUT_AFTER_AUTH:
            draft.proceedToCheckoutAfterAuth = data;
            break;
        case AUTH + SUCCESS:
        case REGISTER + SUCCESS:
            draft.accountFormIsVisible = false;
            draft.accountFormRegisterState = true;
            break;
        case LOGOUT:
            draft.proceedToCheckoutAfterAuth = null;
            break;
        case SAVE_CLIENT_SECRET + REQUEST:
            draft.clientSecretRequest = true;
            break;
        case SAVE_CLIENT_SECRET + SUCCESS:
            const { totalNumber } = action;
            draft.clientSecretRequest = false;
            draft.showCheckoutForm = true;
            if (totalNumber) {
                draft.clientSecretList.push({
                    key: totalNumber,
                    clientSecret: data?.client_secret,
                });
            }
            break;
        case SAVE_CLIENT_SECRET + FAILURE:
            draft.clientSecretRequest = false;
            draft.showCheckoutForm = false;
            break
        case SET_SUBTITLE_TEXT:
            draft.pageSubtitle = data;
            break;
        case SAVE_PROMO_CODES:
            draft.promoCodes = data;
            break;
        case CUSTOM_BILLS:
            draft.customBills = data;
            break
        case MENU_PAYMENT + REQUEST:
            draft.isLoading = true;
            break;
        case MENU_PAYMENT + SUCCESS:
        case MENU_PAYMENT + FAILURE:
            draft.isLoading = false;
            draft.isLoaded = true;
            break;
        default:
            return draft;
    }
});
